import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IAgendaCompromisso } from "../../../../Interfaces/AssistenciaTecnica/Agendamento/AgendamentoInterfaces";
import { faCalendar, faClock, faComment, faFile, faUser } from "@fortawesome/free-solid-svg-icons";
import { useForm } from "react-hook-form";
import { ListarUsuariosController } from "../../../../Controllers/Geral/GestaoUsuarios/UsuariosController";
import useAsyncEffect from "../../../../hooks/useAsyncEffect";
import OrSpinner from "../../../../Components/Utils/OrSpinner";
import moment from "moment";
import "moment/locale/pt-br";
import { useState } from "react";
import { AlterarAgendamentoController } from "../../../../Controllers/AssistenciaTecnica/Agendamento/AgendamentoControllers";
import { useUserInfor } from "../../../../Context/User";

interface IEditarEventoAgendamentoProps {
  agendamento: IAgendaCompromisso;
  endEdit: () => void;
}

interface IFormData {
  ID_USUARIO: number;
  DT_INICIO: string;
  HR_INICIO: string;
  HR_FIM: string;
  DS_ASSUNTO: string;
  DS_DESCRICAO: string;
}

export default function EditarEventoAgendamento(
  props: IEditarEventoAgendamentoProps
) {
  const { FUNCOES } = useUserInfor().UserInfor;
  const mostrarTransferenciaCompromisso = FUNCOES.some((f) => f.NM_FUNCAO === "ADM_TRANSFERIR_COMPROMISSO_AGENDA");

  const { register, handleSubmit, getValues, reset } = useForm();
  const [loading, setLoading] = useState(false);

  const { loading: loadingUsuarios, value: lstUsuarios } = useAsyncEffect(
    ListarUsuariosController, []
  );

  function handleSubmitEdit(formData: IFormData) {
    let dtInicio = formData.DT_INICIO;
    let dtFim = formData.DT_INICIO;

    dtInicio = moment(dtInicio).add(moment.duration(formData.HR_INICIO)).format();
    dtFim = moment(dtFim).add(moment.duration(formData.HR_FIM)).format();

    setLoading(true);
    AlterarAgendamentoController({
      ...formData
      , DT_INICIO: dtInicio
      , DT_FIM: dtFim
      , ID_COMPROMISSO: props.agendamento.ID_COMPROMISSO
      , ID_TIPO_COMPROMISSO: props.agendamento.ID_TIPO_COMPROMISSO
      , ID_USUARIO: (mostrarTransferenciaCompromisso) 
          ? formData.ID_USUARIO
          : props.agendamento.ID_USUARIO
    })
      .finally(() => {
        setLoading(false);
        props.endEdit();
        reset();
      });
  }

  return (
    <OrSpinner spinner="capys" loading={loadingUsuarios || loading}>
      <form
        onSubmit={handleSubmit(
          handleSubmitEdit
        )}
      >
        <div className="my-2">
          {mostrarTransferenciaCompromisso && (
            <div className="form-group">
              <label>Usuário</label>
              <div className="input-group">
                <div className="input-group-prepend">
                  <span className="input-group-text">
                    <FontAwesomeIcon icon={faUser} />
                  </span>
                </div>
                <select
                  className={`form-control`}
                  name="ID_USUARIO"
                  defaultValue={props.agendamento.ID_USUARIO}
                  ref={register({
                    required: true,
                  })}
                >
                  {lstUsuarios?.map((usuario, index) => {
                    return (
                      <option value={usuario.ID_USUARIO}>{usuario.DS_NOME}</option>
                    );
                  })}
                </select>
              </div>
            </div>
          )}
          <div className="form-group">
            <label>Data</label>
            <div className="input-group">
              <div className="input-group-prepend">
                <span className="input-group-text">
                  <FontAwesomeIcon icon={faCalendar} />
                </span>
              </div>
              <input
                type="date"
                className={`form-control`}
                name="DT_INICIO"
                defaultValue={
                  props.agendamento.DT_INICIO
                    ? new Date(
                      props.agendamento.DT_INICIO
                    )
                      .toISOString()
                      .substring(0, 10)
                    : undefined
                }
                ref={register({
                  required: true,
                })}
              />
            </div>
          </div>
          <div className="form-group">
            <label>Horário Início</label>
            <div className="input-group">
              <div className="input-group-prepend">
                <span className="input-group-text">
                  <FontAwesomeIcon icon={faClock} />
                </span>
              </div>
              <input
                type="time"
                className={`form-control`}
                name="HR_INICIO"
                defaultValue={
                  moment(props.agendamento.DT_INICIO).format("HH:mm")
                }
                ref={register({
                  required: true,
                })}
              />
            </div>
          </div>
          <div className="form-group">
            <label>Horário Fim</label>
            <div className="input-group">
              <div className="input-group-prepend">
                <span className="input-group-text">
                  <FontAwesomeIcon icon={faClock} />
                </span>
              </div>
              <input
                type="time"
                className={`form-control`}
                name="HR_FIM"
                defaultValue={
                  moment(props.agendamento.DT_FIM).format("HH:mm")
                }
                ref={register({
                  required: true,
                  validate: {
                    seHorarioFinalMaiorQueInicial:
                      () => {
                        const horasInicio =
                          getValues(
                            "HR_INICIO"
                          ).split(
                            ":"
                          )[0];
                        const minutosInicio =
                          getValues(
                            "HR_INICIO"
                          ).split(
                            ":"
                          )[1];

                        const horasFim =
                          getValues(
                            "HR_FIM"
                          ).split(
                            ":"
                          )[0];
                        const minutosFim =
                          getValues(
                            "HR_FIM"
                          ).split(
                            ":"
                          )[1];

                        const minutosTotalInicio =
                          Number(
                            minutosInicio
                          ) +
                          Number(
                            horasInicio
                          ) *
                          60;

                        const minutosTotalFim =
                          Number(
                            minutosFim
                          ) +
                          Number(
                            horasFim
                          ) *
                          60;

                        let validaHoras =
                          minutosTotalFim -
                          minutosTotalInicio;
                        if (
                          validaHoras >
                          0
                        ) {
                          return true;
                        } else {
                          return "Horário Final Menor que Horário Inicial";
                        }
                      },
                  }
                })}
              />
            </div>
          </div>
          <div className="form-group">
            <label>Assunto</label>
            <div className="input-group">
              <div className="input-group-prepend">
                <span className="input-group-text">
                  <FontAwesomeIcon icon={faComment} />
                </span>
              </div>
              <textarea
                className={`form-control h-50`}
                name="DS_ASSUNTO"
                defaultValue={props.agendamento.DS_ASSUNTO}
                ref={register({
                  required: true,
                })}
              />
            </div>
          </div>
          <div className="form-group">
            <label>Descrição</label>
            <div className="input-group">
              <div className="input-group-prepend">
                <span className="input-group-text">
                  <FontAwesomeIcon icon={faFile} />
                </span>
              </div>
              <textarea
                className={`form-control h-50`}
                name="DS_DESCRICAO"
                defaultValue={props.agendamento.DS_DESCRICAO}
                ref={register({
                  required: true,
                })}
              />
            </div>
          </div>
          <hr />
          <div className="d-flex flex-row-reverse">
            <button
              className="btn btn-outline-success w-50 ml-2"
            >
              Confirmar
            </button>
            <button
              className="btn btn-outline-danger"
              type="button"
              onClick={() => props.endEdit()}
            >
              Cancelar
            </button>
          </div>
        </div>
      </form>
    </OrSpinner>
  );
}